export const searchBarStyles = {
  root: 'relative w-full',
  field:
    'w-full min-h-11 rounded-lg border border-brand-700/35 bg-surface py-2.5 pl-10 pr-4 font-sans text-md text-brand-950 placeholder:text-brand-700/70 focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-400 md:min-h-10 md:text-sm',
} as const;
